import { AbtestType, CohortTreatment } from "@/graphql";

export const mapCohortUpdatePayload = (treatments: CohortTreatment[]) =>
  treatments.map((t) => ({
    rank: t.rank ?? 1,
    segmentId: t.segmentId,
    id: t.id || "",
    // Self-heal: an OFFER-typed treatment with no offers is rejected by the backend's
    // ensureTreatmentIsValid (OfferTreatmentMissingOfferIds), so strip the type when the arm is empty —
    // e.g. after a bulk targeting overwrite moved all its offers to another test.
    treatmentTypes: t.offers?.length ? t.treatmentTypes : t.treatmentTypes.filter((type) => type !== AbtestType.Offer),
    ...(t.shopId ? { shopId: t.shopId } : {}),
    ...(t.offers?.length ? { offers: t.offers } : {}),
    ...(t.classesOverrides
      ? {
          classesOverrides: t.classesOverrides?.map((selectedClass) => {
            const classTechnicalName = selectedClass.class.technicalName;
            return {
              classId: classTechnicalName,
              instances: selectedClass.instances.map((instance) => ({
                id: instance.id,
                enabled: instance.enabled ?? true,
                values: instance.values.map((i) => ({
                  technicalName: i.technicalName,
                  value: i.value,
                })),
              })),
            };
          }),
        }
      : {}),
  }));
